export const cities = [
    {
        "city": "New York", 
        "country": "USA"
    }, 
    {
        "city": "Los Angeles", 
        "country": "USA"
    }, 
    {
        "city": "Chicago", 
        "country": "USA"
    }, 
    {
        "city": "Houston", 
        "country": "USA"
    }, 
    {
        "city": "Philadelphia", 
        "country": "USA"
    }, 
    {
        "city": "Phoenix", 
        "country": "USA"
    }, 
    {
        "city": "San Antonio", 
        "country": "USA"
    }, 
    {
        "city": "San Diego", 
        "country": "USA"
    }, 
    {
        "city": "Dallas", 
        "country": "USA"
    }, 
    {
        "city": "San Jose", 
        "country": "USA"
    }, 
    {
        "city": "Austin", 
        "country": "USA"
    }, 
    {
        "city": "Indianapolis", 
        "country": "USA"
    }, 
    {
        "city": "Jacksonville", 
        "country": "USA"
    }, 
    {
        "city": "San Francisco", 
        "country": "USA"
    }, 
    {
        "city": "Columbus", 
        "country": "USA"
    }, 
    {
        "city": "Charlotte", 
        "country": "USA"
    },
    { 
        "city": "Moscow",
        "country": "Russia"
    },
    { 
        "city": "London",
        "country": "United Kingdom"
    },
    { 
        "city": "Saint Petersburg",
        "country": "Russia"
    },
    { 
        "city": "Berlin",
        "country": "Germany"
    },
    { 
        "city": "Madrid",
        "country": "Spain"
    },
    { 
        "city": "Kyiv",
        "country": "Ukraine"
    },
    { 
        "city": "Rome",
        "country": "Italy"
    },
    { 
        "city": "Paris",
        "country": "France"
    },
    { 
        "city": "Bucharest",
        "country": "Romania"
    },
    { 
        "city": "Minsk",
        "country": "Belarus"
    },
    { 
        "city": "Budapest",
        "country": "Hungary"
    },
    { 
        "city": "Hamburg",
        "country": "Germany"
    },
    { 
        "city": "Warsaw",
        "country": "Poland"
    },
    { 
        "city": "Vienna",
        "country": "Austria"
    },
    { 
        "city": "Barcelona",
        "country": "Spain"
    },
    { 
        "city": "Stockholm",
        "country": "Sweden"
    },
    { 
        "city": "Kharkiv",
        "country": "Ukraine"
    },
    { 
        "city": "Novosibirsk",
        "country": "Russia"
    },
    { 
        "city": "Yekaterinburg",
        "country": "Russia"
    },
    { 
        "city": "Nizhniy Novgorod",
        "country": "Russia"
    },
    { 
        "city": "Belgrade",
        "country": "Serbia"
    },
    { 
        "city": "Munich",
        "country": "Germany"
    },
    { 
        "city": "Milan",
        "country": "Italy"
    },
    { 
        "city": "Prague",
        "country": "Czech Republic"
    },
    { 
        "city": "Copenhagen",
        "country": "Denmark"
    },
    { 
        "city": "Sofia",
        "country": "Bulgaria"
    },
    { 
        "city": "Samara",
        "country": "Russia"
    },
    { 
        "city": "Omsk",
        "country": "Russia"
    },
    { 
        "city": "Kazan",
        "country": "Russia"
    },
    { 
        "city": "Rostov-na-Donu",
        "country": "Russia"
    },
    { 
        "city": "Chelyabinsk",
        "country": "Russia"
    },
    { 
        "city": "Ufa",
        "country": "Russia"
    },
    { 
        "city": "Dnipro",
        "country": "Ukraine"
    },
    { 
        "city": "Donetsk",
        "country": "Ukraine"
    },
    { 
        "city": "Dublin",
        "country": "Ireland"
    },
    { 
        "city": "Brussels",
        "country": "Belgium"
    },
    { 
        "city": "Volgograd",
        "country": "Russia"
    },
    { 
        "city": "Odessa",
        "country": "Ukraine"
    }
]